import React, { useEffect, useState } from "react";
import moment from "moment";
import Calendar from "../../../assets/icons/biCalendar.svg";
import { displayPhoneNumberWithSpace } from "../../../shared/helpers";
import APIVariables from "../../../services/api-variables";
import Axios from "../../../services/Axios";
import useRoles from "../../../hooks/useRoles";
import Wholesaler from "../../common/Wholesaler/Wholesaler";
import TermsAndConditionsPharmacy from "../../common/TermsAndConditions/TermsAndConditionsPharmacy";

const ReRegisterFormPharmacy = ({
  stateRegister,
  registerForm,
  handleChangeCheckBox,
  setWasLinkClicked,
  setDownloadedBrochures,
  downloadedBrochures,
  setIsNextButtonDisabled,
}) => {
  const [brochureId, setBrochureId] = useState(null);
  const { isPrimaryPharmacist } = useRoles();
  useEffect(
    () => {
      getBrochureId();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const getBrochureId = async () => {
    await Axios.get(APIVariables.HCP_BROCHURE_INFO)
      .then((res) => {
        const { status, data } = res;

        if (status === 200) {
          setBrochureId(data?.hp_information_brochure);
        }
      })
      .catch(() => {});
  };

  const getBrochure = async (openInNewPage = false) => {
    setWasLinkClicked(true);
    setIsNextButtonDisabled(true);
    await Axios.get(APIVariables.PATIENTS_BROCHURES_DOWNLOAD + brochureId)
      .then((res) => {
        const { data, status } = res;
        if (status === 200) {
          const { brochure_history_id } = data;
          setDownloadedBrochures([...downloadedBrochures, brochure_history_id]);
          return data?.report;
        }
        return null;
      })
      .then(async (brochureString) => {
        const base64 = await fetch(
          `data:application/pdf;base64,${brochureString}`
        );
        return base64.blob();
      })
      .then((blob) => {
        const file = new Blob([blob], {
          type: "application/pdf",
        });
        const fileURL = URL.createObjectURL(file);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileURL;
        if (openInNewPage) {
          downloadLink.target = "_blank";
        } else {
          downloadLink.download = `${"Lenalidomide"}.pdf`;
        }
        downloadLink.click();
        downloadLink.remove();
        URL.revokeObjectURL(downloadLink.href);
      })
      .catch(() => {})
      .finally(() => {
        setIsNextButtonDisabled(false);
      });
  };
  return (
    <React.Fragment>
      {stateRegister === 1 && (
        <React.Fragment>
          <h1 className="select-category-txt">
            Pharmacist Re-Registration Form
          </h1>

          <hr className="gray-hr" />

          <div className="group-back">
            <div>Pharmacist Re-Registration Form</div>
          </div>
          <div className="wrapper-brackground">
            <h2 className="title-details">Pharmacist Details</h2>

            <div className="bold mineShaft-color font-size-18 mb-5">
              Please confirm your details below. If any details are incorrect,
              please notify Pharmacare Group immeadiately of any changes to be
              made to your account.
            </div>
            <div className="container mt-5">
              <div className="row">
                <div className="col">
                  <label>
                    {isPrimaryPharmacist
                      ? "Pharmacist (or appointed deputy) First Name:"
                      : "First Name Pharmacist:"}
                  </label>
                  <input
                    type="text"
                    name="first_name"
                    value={registerForm?.first_name}
                    disabled
                  />
                </div>
                <div className="col">
                  <label>
                    {isPrimaryPharmacist
                      ? "Pharmacist (or appointed deputy) Last Name:"
                      : "Last Name Pharmacist:"}
                  </label>
                  <input
                    type="text"
                    name="last_name"
                    value={registerForm?.last_name}
                    disabled
                  />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label>GPhC / PSNI Registration Number:</label>
                  <input
                    type="text"
                    name="registration_number"
                    value={registerForm?.registration_number}
                    disabled
                  />
                </div>
                <div className="col">
                  <label>Institution type:</label>
                  <input
                    type="text"
                    name="institution_type"
                    value={registerForm?.pharmacy?.institution_type}
                    disabled
                  />
                </div>

                <div className="row">
                  <div className="col">
                    <label>Phone Number:</label>
                    <input
                      type="text"
                      name="phone_number"
                      value={displayPhoneNumberWithSpace(
                        registerForm?.phone_number
                      )}
                      disabled
                    />
                  </div>
                  <div className="col" style={{ marginRight: "-24px" }}>
                    <label>Institution Name:</label>
                    <input
                      type="text"
                      name="institution_name"
                      value={registerForm?.pharmacy?.value}
                      disabled
                    />
                  </div>
                </div>
                {!isPrimaryPharmacist && (
                  <div className="row">
                    <div className="col">
                      <label>Job Title:</label>
                      <input
                        type="text"
                        name="job_title"
                        value={registerForm?.job_title}
                        disabled
                      />
                    </div>
                    <div className="col" />
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col">
                  <label>Dispensing Pharmacy Address:</label>
                  <input
                    type="text"
                    name="address1"
                    value={registerForm?.pharmacy?.address}
                    disabled
                  />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label>Delivery Address (if different):</label>
                  <input
                    type="text"
                    name="delivery_address"
                    value={registerForm?.pharmacy?.delivery_address}
                    placeholder="Only complete if different to the address listed above"
                    disabled
                  />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label>
                    Ordering Address (If different to delivery address):
                  </label>
                  <input
                    type="text"
                    name="ordering_address"
                    value={registerForm?.pharmacy?.ordering_address}
                    placeholder="Only complete if different to the address listed above"
                    disabled
                  />
                </div>
              </div>
            </div>

            <h2 className="title-details mt-2">Wholesaler Details</h2>
            <div className="row mb-3" style={{ position: "relative" }}>
              {(registerForm.wholesalers_data || []).map((wholesaler) => (
                <div className="col-md-6" key={wholesaler.id}>
                  <Wholesaler
                    registerForm={registerForm}
                    wholesaler={wholesaler}
                    isEditMode={false}
                  />
                </div>
              ))}
            </div>

            <h2 className="title-details mt-2">Account Details</h2>

            <div className="container">
              <div className="row">
                <div className="col">
                  <label>Email Address:</label>
                  <input
                    type="text"
                    name="email"
                    value={registerForm?.email}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}

      <React.Fragment>
        {stateRegister === 2 && (
          <React.Fragment>
            <h1 className="select-category-txt">
              Pharmacist Re-Registration Form
            </h1>

            <hr className="gray-hr" />

            <div className="confirm">
              By registering {registerForm?.pharmacy?.value} to order and
              dispense Lenalidomide, I agree to implement and ensure compliance
              with the risk minimisation measures associated with the Pregnancy
              Prevention Programme (PPP) for Lenalidomide and adhere to the
              following requirements:
            </div>

            <React.Fragment>
              <TermsAndConditionsPharmacy
                getBrochure={getBrochure}
                registerForm={registerForm}
                handleChangeCheckBox={handleChangeCheckBox}
              />
            </React.Fragment>

            <div className="container sign">
              <div className="row">
                <div className="col">
                  <label>Pharmacist Name:</label>
                  <input
                    type="text"
                    name="pharmacistName"
                    value={
                      registerForm?.first_name + " " + registerForm?.last_name
                    }
                    disabled
                  />
                </div>
                <div className="col">
                  <label>Date:</label>
                  <input
                    className="transparent-background"
                    value={moment().format("DD / MM / YYYY")}
                    disabled
                  />
                  <img src={Calendar} alt="Calendar" className="calendar" />
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    </React.Fragment>
  );
};
export default ReRegisterFormPharmacy;
